module.exports = __webpack_public_path__ + "907b2f50a.jpg";